module.exports = __webpack_public_path__ + "img/icon-tools.b066ac9b.svg";